import React from "react";

const Til = () => {
  return (
    <div className="container my-3">
      <div className="abouts">
        <h5>Til</h5>
      </div>

      <div
        className="about-box p-4 rounded shadow-lg table-responsive"
        style={{ textAlign: "justify" }}
      >
        <table className="table table-striped table-bordered">
          <thead className="text-center">
            <tr>
              <th>Seed Rate</th>
              <th>Sowing Time</th>
              <th>Irrigation</th>
              <th>Maturity Time</th>
              <th>Characterstics</th>
              <th>Average Yield</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td colspan="6">
                <strong>HT - 1 [Released in 19.12.1978]</strong>
              </td>
            </tr>
            <tr>
              <td>2 kgs per acre.</td>
              <td>1st week of July or at the time of the onset of Monsoon.</td>
              <td>
                1-2 irrigations. In drought conditions irrigation is must at
                flowering and fruiting stage.
              </td>
              <td>77 days.</td>
              <td>
                Medium plant height. Leaves are dark green and seed is white
                coloured and heavy. Resitant to leaf curl disease. Oil content
                is approximately 49%.
              </td>
              <td>3 quintals per acre.</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Til;
